import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from './CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from './json/internal/FileUploadAwareJsonWriter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from './json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from './json/JsonWriters.mjs';
import { UploadsHttpBody13sq2iwgyese9 as UploadsHttpBody } from './http/DefaultHttpRequestComposer.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toMap(_this__u8e3s4) {
  // Inline function 'kotlin.check' call
  if (!_this__u8e3s4.uploads_1.isEmpty_y1axqb_k$()) {
    var message = 'Apollo: sending uploads in this context is an error. Uploads are not supported by default for GET requests or subscriptions.';
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  }
  return toMapUnsafe(_this__u8e3s4);
}
var RequestParametersClass;
function RequestParameters() {
  if (RequestParametersClass === VOID) {
    class $ {
      constructor(query, operationName, variables, extensions, uploads, onError) {
        this.query_1 = query;
        this.operationName_1 = operationName;
        this.variables_1 = variables;
        this.extensions_1 = extensions;
        this.uploads_1 = uploads;
        this.onError_1 = onError;
      }
    }
    initMetadataForClass($, 'RequestParameters');
    RequestParametersClass = $;
  }
  return RequestParametersClass;
}
function toRequestParameters(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.sendApqExtensions_1;
  var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  var sendEnhancedClientAwarenessExtensions = _this__u8e3s4.sendEnhancedClientAwareness_1;
  var tmp1_elvis_lhs = _this__u8e3s4.sendDocument_1;
  var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = _this__u8e3s4.executionContext_1.get_ourcpn_k$(Key_getInstance());
  var scalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().Empty_1 : tmp2_elvis_lhs;
  var jsonWriter = new (MapJsonWriter())();
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(jsonWriter);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.beginObject_5wddq0_k$();
  _this__u8e3s4.operation_1.serializeVariables_bugef7_k$(uploadAwareWriter, scalarAdapters, false);
  uploadAwareWriter.endObject_ofuv3u_k$();
  var tmp = jsonWriter.root_235k2_k$();
  var variables = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var ext = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  if (sendApqExtensions) {
    ext.put_4fpzoq_k$('persistedQuery', mapOf([to('version', 1), to('sha256Hash', _this__u8e3s4.operation_1.operationId())]));
  }
  if (sendEnhancedClientAwarenessExtensions) {
    ext.put_4fpzoq_k$('clientLibrary', mapOf([to('name', 'apollo-kotlin'), to('version', '5.1.0')]));
  }
  if (!(_this__u8e3s4.extensions_1 == null)) {
    ext.putAll_wgg6cj_k$(_this__u8e3s4.extensions_1);
  }
  var tmp_0 = sendDocument ? _this__u8e3s4.operation_1.document_e91o2j_k$() : null;
  var tmp_1 = _this__u8e3s4.operation_1.operationName();
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = uploadAwareWriter.collectedUploads_cst71z_k$();
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_0.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_2 = 'variables.' + element.get_key_18j28a_k$();
    var tmp$ret$7 = element.get_value_j01efc_k$();
    destination.put_4fpzoq_k$(tmp_2, tmp$ret$7);
  }
  return new (RequestParameters())(tmp_0, tmp_1, variables, ext, destination, _this__u8e3s4.onError_1);
}
function toHttpBody(_this__u8e3s4) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  writeAny($this$buildJsonByteString, toMapUnsafe(_this__u8e3s4));
  var byteString = buffer.readByteString_nzt46n_k$();
  var tmp;
  if (_this__u8e3s4.uploads_1.isEmpty_y1axqb_k$()) {
    tmp = new (toHttpBody$1())(byteString);
  } else {
    tmp = new (UploadsHttpBody())(_this__u8e3s4.uploads_1, byteString);
  }
  return tmp;
}
function toMapUnsafe(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  if (!(_this__u8e3s4.query_1 == null)) {
    this_0.put_4fpzoq_k$('query', _this__u8e3s4.query_1);
  }
  this_0.put_4fpzoq_k$('operationName', _this__u8e3s4.operationName_1);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!_this__u8e3s4.variables_1.isEmpty_y1axqb_k$()) {
    this_0.put_4fpzoq_k$('variables', _this__u8e3s4.variables_1);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!_this__u8e3s4.extensions_1.isEmpty_y1axqb_k$()) {
    this_0.put_4fpzoq_k$('extensions', _this__u8e3s4.extensions_1);
  }
  if (!(_this__u8e3s4.onError_1 == null)) {
    this_0.put_4fpzoq_k$('onError', _this__u8e3s4.onError_1.toString());
  }
  return this_0.build_nmwvly_k$();
}
var toHttpBody$1Class;
function toHttpBody$1() {
  if (toHttpBody$1Class === VOID) {
    class $ {
      constructor($byteString) {
        this.$byteString_1 = $byteString;
        this.contentType_1 = 'application/json';
        this.contentLength_1 = fromInt($byteString.get_size_woubt6_k$());
      }
      get_contentType_7git4a_k$() {
        return this.contentType_1;
      }
      get_contentLength_a5o8yy_k$() {
        return this.contentLength_1;
      }
      writeTo_nko22i_k$(bufferedSink) {
        bufferedSink.write_nkn6vw_k$(this.$byteString_1);
      }
    }
    initMetadataForClass($);
    toHttpBody$1Class = $;
  }
  return toHttpBody$1Class;
}
//region block: exports
export {
  toHttpBody as toHttpBody2x6lfaxkoi6pf,
  toMap as toMap14rbdrx2whbk6,
  toRequestParameters as toRequestParameters3ovu7e0943da8,
};
//endregion

//# sourceMappingURL=RequestParameters.mjs.map
